import * as React from 'react';

type LineInfoProps = {
  title: string;
  value: string | undefined;
  placeholder?: string;
  className?: string;
};
export const LineInfo = ({ title, value, placeholder, className }: LineInfoProps) => {
  return (
    <div className={className || 'mb-2'}>
      <strong>{title}:</strong> {value || placeholder}
    </div>
  );
};
